import { Helmet } from 'react-helmet'

import { useLead } from '@itau-loans-www/hooks'
import { MainLayout } from '@itau-loans-www/templates'
import { isClient } from '@itau-loans-www/utils'
import classnames from 'classnames'

import './summary.scss'

export default ({ children, className, ...props }) => {
  const {
    isPartner,
    leadData: { partner }
  } = useLead()

  const classNamesLayout = classnames('summary-layout', {
    'summary-layout--partner': isClient() && partner,
    'summary-layout--magalu': isClient() && isPartner('magalu'),
    'summary-layout--telhaNorte': isClient() && isPartner('telhaNorte'),
    'summary-layout--assai': isClient() && isPartner('assai'),
    'summary-layout--pirelli': isClient() && isPartner('pirelli'),
    'summary-layout--carrefour': isClient() && isPartner('carrefour'),
    'summary-layout--crediffato': isClient() && isPartner('crediffato'),
    'summary-layout--atacadao': isClient() && isPartner('atacadao'),
    [className]: className
  })

  const classNamesContent = classnames('summary-content', {
    [className]: className
  })

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div {...props} className={classNamesLayout}>
        <MainLayout partnerName={partner} hasFooter currentPage="result">
          <main className={classNamesContent}>
            <div className="image-wrapper" />

            {children}
          </main>
        </MainLayout>
      </div>
    </>
  )
}
